webpackJsonp([79611799117203,60335399758886],{

/***/ 168:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(289);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(168);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(4));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(230));
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    for (var key in listeners) {
	      // $FlowFixMe
	      var listener = listeners[key];
	
	      if (listener === undefined) {
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return {
	    publish: publish,
	    subscribe: subscribe,
	    unsubscribe: unsubscribe
	  };
	};
	
	var channel = '__EMOTION_THEMING__';
	
	var _contextTypes;
	
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	// adapted from styled-components' ThemeProvider
	// https://github.com/styled-components/styled-components/blob/4503cab5b86aa9ef8314c5baa360a2fbb4812485/src/models/ThemeProvider.js
	var isPlainObject = function isPlainObject(test) {
	  return Object.prototype.toString.call(test) === '[object Object]';
	};
	
	function _componentWillMount() {
	  var _this2 = this;
	
	  function _ref2(theme) {
	    _this2.outerTheme = theme;
	
	    if (_this2.broadcast !== undefined) {
	      _this2.publish(_this2.props.theme);
	    }
	  }
	
	  // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	  // with the outer theme
	  if (this.context[channel] !== undefined) {
	    this.unsubscribeToOuterId = this.context[channel].subscribe(_ref2);
	  }
	
	  this.broadcast = createBroadcast(this.getTheme(this.props.theme));
	}
	
	function _getChildContext() {
	  var _ref;
	
	  return _ref = {}, _ref[channel] = {
	    subscribe: this.broadcast.subscribe,
	    unsubscribe: this.broadcast.unsubscribe
	  }, _ref;
	}
	
	function _componentWillReceive(nextProps) {
	  if (this.props.theme !== nextProps.theme) {
	    this.publish(nextProps.theme);
	  }
	}
	
	function _componentWillUnmount() {
	  var themeContext = this.context[channel];
	
	  if (themeContext !== undefined) {
	    themeContext.unsubscribe(this.unsubscribeToOuterId);
	  }
	}
	
	function _getTheme(theme) {
	  if (typeof theme === 'function') {
	    var mergedTheme = theme(this.outerTheme);
	
	    if (!isPlainObject(mergedTheme)) {
	      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	    }
	
	    return mergedTheme;
	  }
	
	  if (!isPlainObject(theme)) {
	    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	  }
	
	  if (this.outerTheme === undefined) {
	    return theme;
	  }
	
	  return _extends({}, this.outerTheme, theme);
	}
	
	function _publish(theme) {
	  this.broadcast.publish(this.getTheme(theme));
	}
	
	function _render() {
	  if (!this.props.children) {
	    return null;
	  }
	
	  return React.Children.only(this.props.children);
	}
	
	var ThemeProvider =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    var _this;
	
	    _this = _Component.call(this) || this;
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  var _proto = ThemeProvider.prototype;
	  _proto.componentWillMount = _componentWillMount;
	  _proto.getChildContext = _getChildContext;
	  _proto.componentWillReceiveProps = _componentWillReceive;
	  _proto.componentWillUnmount = _componentWillUnmount; // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	  _proto.getTheme = _getTheme;
	  _proto.publish = _publish;
	  _proto.render = _render;
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = contextTypes;
	ThemeProvider.contextTypes = contextTypes;
	
	function _componentWillMount$1() {
	  var _this = this;
	
	  var themeContext = this.context[channel];
	
	  if (themeContext === undefined) {
	    // eslint-disable-next-line no-console
	    console.error('[withTheme] Please use ThemeProvider to be able to use withTheme');
	    return;
	  }
	
	  this.unsubscribeId = themeContext.subscribe(function (theme) {
	    _this.setState({
	      theme: theme
	    });
	  });
	}
	
	function _componentWillUnmount$1() {
	  if (this.unsubscribeId !== -1) {
	    this.context[channel].unsubscribe(this.unsubscribeId);
	  }
	}
	
	var withTheme = function withTheme(Component$$1) {
	  var componentName = Component$$1.displayName || Component$$1.name || 'Component';
	
	  function _render() {
	    return React.createElement(Component$$1, _extends({
	      theme: this.state.theme
	    }, this.props));
	  }
	
	  var WithTheme =
	  /*#__PURE__*/
	  function (_React$Component) {
	    _inheritsLoose(WithTheme, _React$Component);
	
	    function WithTheme() {
	      return _React$Component.apply(this, arguments) || this;
	    }
	
	    var _proto = WithTheme.prototype;
	    _proto.componentWillMount = _componentWillMount$1;
	    _proto.componentWillUnmount = _componentWillUnmount$1;
	    _proto.render = _render;
	    return WithTheme;
	  }(React.Component);
	
	  WithTheme.displayName = "WithTheme(" + componentName + ")";
	  WithTheme.contextTypes = contextTypes;
	  return hoistNonReactStatics(WithTheme, Component$$1);
	};
	
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.channel = channel;
	exports.contextTypes = contextTypes;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(826)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowequal = __webpack_require__(265);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _raf = __webpack_require__(884);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldUpdate2 = __webpack_require__(887);
	
	var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-unresolved
	
	
	var noop = function noop() {};
	
	var Headroom = function (_Component) {
	  _inherits(Headroom, _Component);
	
	  function Headroom(props) {
	    _classCallCheck(this, Headroom);
	
	    // Class variables.
	    var _this = _possibleConstructorReturn(this, (Headroom.__proto__ || Object.getPrototypeOf(Headroom)).call(this, props));
	
	    _this.setRef = function (ref) {
	      return _this.inner = ref;
	    };
	
	    _this.setHeightOffset = function () {
	      _this.setState({
	        height: _this.inner.offsetHeight
	      });
	      _this.resizeTicking = false;
	    };
	
	    _this.getScrollY = function () {
	      if (_this.props.parent().pageYOffset !== void 0) {
	        return _this.props.parent().pageYOffset;
	      } else if (_this.props.parent().scrollTop !== void 0) {
	        return _this.props.parent().scrollTop;
	      } else {
	        return (document.documentElement || document.body.parentNode || document.body).scrollTop;
	      }
	    };
	
	    _this.getViewportHeight = function () {
	      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	    };
	
	    _this.getDocumentHeight = function () {
	      var body = document.body;
	      var documentElement = document.documentElement;
	
	      return Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight, body.clientHeight, documentElement.clientHeight);
	    };
	
	    _this.getElementPhysicalHeight = function (elm) {
	      return Math.max(elm.offsetHeight, elm.clientHeight);
	    };
	
	    _this.getElementHeight = function (elm) {
	      return Math.max(elm.scrollHeight, elm.offsetHeight, elm.clientHeight);
	    };
	
	    _this.getScrollerPhysicalHeight = function () {
	      var parent = _this.props.parent();
	
	      return parent === window || parent === document.body ? _this.getViewportHeight() : _this.getElementPhysicalHeight(parent);
	    };
	
	    _this.getScrollerHeight = function () {
	      var parent = _this.props.parent();
	
	      return parent === window || parent === document.body ? _this.getDocumentHeight() : _this.getElementHeight(parent);
	    };
	
	    _this.isOutOfBound = function (currentScrollY) {
	      var pastTop = currentScrollY < 0;
	
	      var scrollerPhysicalHeight = _this.getScrollerPhysicalHeight();
	      var scrollerHeight = _this.getScrollerHeight();
	
	      var pastBottom = currentScrollY + scrollerPhysicalHeight > scrollerHeight;
	
	      return pastTop || pastBottom;
	    };
	
	    _this.handleScroll = function () {
	      if (!_this.scrollTicking) {
	        _this.scrollTicking = true;
	        (0, _raf2.default)(_this.update);
	      }
	    };
	
	    _this.handleResize = function () {
	      if (!_this.resizeTicking) {
	        _this.resizeTicking = true;
	        (0, _raf2.default)(_this.setHeightOffset);
	      }
	    };
	
	    _this.unpin = function () {
	      _this.props.onUnpin();
	
	      _this.setState({
	        translateY: '-100%',
	        className: 'headroom headroom--unpinned'
	      }, function () {
	        setTimeout(function () {
	          _this.setState({ state: 'unpinned' });
	        }, 0);
	      });
	    };
	
	    _this.pin = function () {
	      _this.props.onPin();
	
	      _this.setState({
	        translateY: 0,
	        className: 'headroom headroom--pinned',
	        state: 'pinned'
	      });
	    };
	
	    _this.unfix = function () {
	      _this.props.onUnfix();
	
	      _this.setState({
	        translateY: 0,
	        className: 'headroom headroom--unfixed',
	        state: 'unfixed'
	      });
	    };
	
	    _this.update = function () {
	      _this.currentScrollY = _this.getScrollY();
	
	      if (!_this.isOutOfBound(_this.currentScrollY)) {
	        var _shouldUpdate = (0, _shouldUpdate3.default)(_this.lastKnownScrollY, _this.currentScrollY, _this.props, _this.state),
	            action = _shouldUpdate.action;
	
	        if (action === 'pin') {
	          _this.pin();
	        } else if (action === 'unpin') {
	          _this.unpin();
	        } else if (action === 'unfix') {
	          _this.unfix();
	        }
	      }
	
	      _this.lastKnownScrollY = _this.currentScrollY;
	      _this.scrollTicking = false;
	    };
	
	    _this.currentScrollY = 0;
	    _this.lastKnownScrollY = 0;
	    _this.scrollTicking = false;
	    _this.resizeTicking = false;
	    _this.state = {
	      state: 'unfixed',
	      translateY: 0,
	      className: 'headroom headroom--unfixed'
	    };
	    return _this;
	  }
	
	  _createClass(Headroom, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setHeightOffset();
	      if (!this.props.disable) {
	        this.props.parent().addEventListener('scroll', this.handleScroll);
	
	        if (this.props.calcHeightOnResize) {
	          this.props.parent().addEventListener('resize', this.handleResize);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disable && !this.props.disable) {
	        this.unfix();
	        this.props.parent().removeEventListener('scroll', this.handleScroll);
	        this.props.parent().removeEventListener('resize', this.handleResize);
	      } else if (!nextProps.disable && this.props.disable) {
	        this.props.parent().addEventListener('scroll', this.handleScroll);
	
	        if (this.props.calcHeightOnResize) {
	          this.props.parent().addEventListener('resize', this.handleResize);
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // If children have changed, remeasure height.
	      if (prevProps.children !== this.props.children) {
	        this.setHeightOffset();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.parent().removeEventListener('scroll', this.handleScroll);
	      window.removeEventListener('scroll', this.handleScroll);
	      this.props.parent().removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          userClassName = _props.className,
	          divProps = _objectWithoutProperties(_props, ['className']);
	
	      delete divProps.onUnpin;
	      delete divProps.onPin;
	      delete divProps.onUnfix;
	      delete divProps.disableInlineStyles;
	      delete divProps.disable;
	      delete divProps.parent;
	      delete divProps.children;
	      delete divProps.upTolerance;
	      delete divProps.downTolerance;
	      delete divProps.pinStart;
	      delete divProps.calcHeightOnResize;
	
	      var style = divProps.style,
	          wrapperStyle = divProps.wrapperStyle,
	          rest = _objectWithoutProperties(divProps, ['style', 'wrapperStyle']);
	
	      var innerStyle = {
	        position: this.props.disable || this.state.state === 'unfixed' ? 'relative' : 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        zIndex: 1,
	        WebkitTransform: 'translateY(' + this.state.translateY + ')',
	        MsTransform: 'translateY(' + this.state.translateY + ')',
	        transform: 'translateY(' + this.state.translateY + ')'
	      };
	
	      var className = this.state.className;
	
	      // Don't add css transitions until after we've done the initial
	      // negative transform when transitioning from 'unfixed' to 'unpinned'.
	      // If we don't do this, the header will flash into view temporarily
	      // while it transitions from 0 — -100%.
	      if (this.state.state !== 'unfixed') {
	        innerStyle = _extends({}, innerStyle, {
	          WebkitTransition: 'all .2s ease-in-out',
	          MozTransition: 'all .2s ease-in-out',
	          OTransition: 'all .2s ease-in-out',
	          transition: 'all .2s ease-in-out'
	        });
	        className += ' headroom--scrolled';
	      }
	
	      if (!this.props.disableInlineStyles) {
	        innerStyle = _extends({}, innerStyle, style);
	      } else {
	        innerStyle = style;
	      }
	
	      var wrapperStyles = _extends({}, wrapperStyle, {
	        height: this.state.height ? this.state.height : null
	      });
	
	      var wrapperClassName = userClassName ? userClassName + ' headroom-wrapper' : 'headroom-wrapper';
	
	      return _react2.default.createElement(
	        'div',
	        { style: wrapperStyles, className: wrapperClassName },
	        _react2.default.createElement(
	          'div',
	          _extends({
	            ref: this.setRef
	          }, rest, {
	            style: innerStyle,
	            className: className
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Headroom;
	}(_react.Component);
	
	Headroom.propTypes = {
	  className: _propTypes2.default.string,
	  parent: _propTypes2.default.func,
	  children: _propTypes2.default.any.isRequired,
	  disableInlineStyles: _propTypes2.default.bool,
	  disable: _propTypes2.default.bool,
	  upTolerance: _propTypes2.default.number,
	  downTolerance: _propTypes2.default.number,
	  onPin: _propTypes2.default.func,
	  onUnpin: _propTypes2.default.func,
	  onUnfix: _propTypes2.default.func,
	  wrapperStyle: _propTypes2.default.object,
	  pinStart: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  calcHeightOnResize: _propTypes2.default.bool
	};
	Headroom.defaultProps = {
	  parent: function parent() {
	    return window;
	  },
	  disableInlineStyles: false,
	  disable: false,
	  upTolerance: 5,
	  downTolerance: 0,
	  onPin: noop,
	  onUnpin: noop,
	  onUnfix: noop,
	  wrapperStyle: {},
	  pinStart: 0,
	  calcHeightOnResize: true
	};
	exports.default = Headroom;

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var lastKnownScrollY = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
	  var currentScrollY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
	  var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	  var state = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
	
	  var scrollDirection = currentScrollY >= lastKnownScrollY ? 'down' : 'up';
	  var distanceScrolled = Math.abs(currentScrollY - lastKnownScrollY);
	
	  // We're disabled
	  if (props.disable) {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're at the top and not fixed yet.
	  } else if (currentScrollY <= props.pinStart && state.state !== 'unfixed') {
	    return {
	      action: 'unfix',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're unfixed and headed down. Carry on.
	  } else if (currentScrollY <= state.height && scrollDirection === 'down' && state.state === 'unfixed') {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're past the header and scrolling down.
	    // We transition to "unpinned" if necessary.
	  } else if (scrollDirection === 'down' && ['pinned', 'unfixed'].indexOf(state.state) >= 0 && currentScrollY > state.height + props.pinStart && distanceScrolled > props.downTolerance) {
	    return {
	      action: 'unpin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're scrolling up, we transition to "pinned"
	  } else if (scrollDirection === 'up' && distanceScrolled > props.upTolerance && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
	    return {
	      action: 'pin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're scrolling up, and inside the header.
	    // We transition to pin regardless of upTolerance
	  } else if (scrollDirection === 'up' && currentScrollY <= state.height && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
	    return {
	      action: 'pin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	  } else {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	  }
	};

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactHeadroom = __webpack_require__(886);
	
	var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);
	
	var _Trophy = __webpack_require__(44);
	
	var _Trophy2 = _interopRequireDefault(_Trophy);
	
	var _History = __webpack_require__(43);
	
	var _History2 = _interopRequireDefault(_History);
	
	var _HandsHelping = __webpack_require__(42);
	
	var _HandsHelping2 = _interopRequireDefault(_HandsHelping);
	
	var _Triangle = __webpack_require__(81);
	
	var _Triangle2 = _interopRequireDefault(_Triangle);
	
	var _theme = __webpack_require__(14);
	
	var _OrbContainer = __webpack_require__(192);
	
	var _DarkIcon = __webpack_require__(285);
	
	var _DarkIcon2 = _interopRequireDefault(_DarkIcon);
	
	var _LightIcon = __webpack_require__(286);
	
	var _LightIcon2 = _interopRequireDefault(_LightIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 18.675 pixel/rem
	// 1540px; 82.46rem;
	// 1920px; 102.8112rem;
	
	// import Logo from "../icons/logo/Logo";
	var HeadroomWrapDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e93nftf0'
	})('display:flex;width:100%;background-color:red;', HeadRoom, '{.headroom--unpinned{}}');
	var HeadroomDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e93nftf1'
	})('font-size:1.1225rem;display:flex;margin-left:auto;margin-right:auto;width:100%;max-width:', function (props) {
	  return props.theme.layout.max;
	}, ';margin-bottom:1rem;');
	var LinkLogo = /*#__PURE__*/(0, _reactEmotion2.default)(_gatsbyLink2.default, {
	  target: 'e93nftf2'
	})('position:absolute;top:0.5rem;z-index:99;font-weight:700;svg{height:2.5rem;margin-bottom:0;}display:inline-block;font-size:1.25rem;margin-left:0.75rem;font-family:', function (props) {
	  return props.theme.fontFamily.button;
	}, ';transition:all 0.4s;text-shadow:0rem 0.3rem 0.5rem rgba(0,0,0,0.45);color:', function (props) {
	  return props.theme.colors.cool.dim0;
	}, ';border-bottom:2px solid ', function (props) {
	  return props.theme.colors.warm.base;
	}, ';&:focus,&:hover{border-bottom:2px solid ', function (props) {
	  return props.theme.colors.fire.light;
	}, ';color:', function (props) {
	  return props.theme.colors.cool.lead;
	}, ';text-shadow:0rem 0.3rem 0.5rem rgba(0,0,0,0.45),-1px -1px 0 ', function (props) {
	  return props.theme.colors.cool.dim0;
	}, ',1px -1px 0 ', function (props) {
	  return props.theme.colors.cool.dim0;
	}, ',-1px 1px 0 ', function (props) {
	  return props.theme.colors.cool.dim0;
	}, ',1px 1px 0 ', function (props) {
	  return props.theme.colors.cool.dim0;
	}, ';}@media (max-width:500px){margin-left:-0.75rem;}');
	var Tri = /*#__PURE__*/(0, _reactEmotion2.default)(_Triangle2.default, {
	  target: 'e93nftf3'
	})('transform:skewX(0deg) scale(0.15);background-color:', function (props) {
	  return props.theme.set.dark.invertWhite;
	}, ';top:-4.8rem;left:-3.95rem;z-index:99;opacity:0.85;transition:', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';@media (max-width:600px){top:-4.99rem;left:-4.5rem;}');
	var BgTri = /*#__PURE__*/(0, _reactEmotion2.default)(_Triangle2.default, {
	  target: 'e93nftf4'
	})('transform:skewX(0deg) scale(0.2);background-color:', function (props) {
	  return props.theme.set.dark.bgText;
	}, ';top:-14.8rem;left:-3.95rem;z-index:98;opacity:0.95;transition:', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';@media (max-width:600px){top:-14.99rem;left:-4.5rem;}');
	var ShadowTri = /*#__PURE__*/(0, _reactEmotion2.default)(_Triangle2.default, {
	  target: 'e93nftf5'
	})('transform:skewX(0deg) scale(0.22);background-color:', function (props) {
	  return props.theme.colors.cool.lead;
	}, ';top:-24.8rem;left:-3.95rem;z-index:97;opacity:0.25;transition:', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';@media (max-width:600px){top:-24.99rem;left:-4.5rem;}');
	var TriLink = /*#__PURE__*/(0, _reactEmotion2.default)(_gatsbyLink2.default, {
	  target: 'e93nftf6'
	})('max-width:1rem;max-height:1rem;&:focus,&:hover{', ShadowTri, '{opacity:0.75;background-color:', function (props) {
	  return props.theme.colors.warm.base;
	}, ';}}padding-left:2.25rem;padding-right:0.95rem;@media (max-width:600px){padding-right:0;padding-left:2.25rem;}');
	
	// const NavWrapDiv = styled.div`
	//   display: inline;
	//   width: 100%;
	// `;
	
	var InlineBlockDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e93nftf7'
	})('display:inline-block;');
	
	var Nav = /*#__PURE__*/(0, _reactEmotion2.default)('span', {
	  target: 'e93nftf8'
	})('display:flex;position:relative;flex-direction:row-reverse;text-align:center;min-width:300px;transition:all 0.25s;z-index:98;/*\n  background-color:green;*/\n  font-family:', function (props) {
	  return props.theme.fontFamily.button;
	}, ';svg{g{stroke:', function (props) {
	  return props.theme.set.light.placeholder;
	}, ';fill:', function (props) {
	  return props.theme.colors.cool.dim0;
	}, ';stroke-width:18;}}margin-bottom:-1.25rem;a{font-weight:2rem;margin-left:1rem;}padding-left:4rem;', TriLink, '{border-bottom:2px solid transparent;cursor:pointer;&:focus,&:hover{border-bottom:2px solid transparent;}}@media (max-width:724px){padding-left:6rem;}@media (max-width:500px){padding-left:4rem;}');
	var LinkNav = /*#__PURE__*/(0, _reactEmotion2.default)(_gatsbyLink2.default, {
	  target: 'e93nftf9'
	})('/* \nbackground-color:red;*/\ntext-shadow:0.25rem 0.2rem 0.25rem rgba(0,0,0,1),', function (props) {
	  return props.theme.set.light.shadow.pop;
	}, ';transition:all 0.4s;/*\n  border-bottom:2px solid transparent;*/\n  &:focus{color:', function (props) {
	  return props.theme.colors.pure.white;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThick;
	}, ';svg{g{fill:', function (props) {
	  return props.theme.colors.pure.white;
	}, ';}}}&:hover{border-bottom:2px solid ', function (props) {
	  return props.theme.colors.warm.base;
	}, ';color:', function (props) {
	  return props.theme.colors.pure.white;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThick;
	}, ';svg{g{fill:', function (props) {
	  return props.theme.colors.pure.white;
	}, ';}}}');
	var HeadRoom = /*#__PURE__*/(0, _reactEmotion2.default)(_reactHeadroom2.default, {
	  target: 'e93nftf10'
	})(LinkLogo, '{color:', function (props) {
	  return props.theme.colors.cool.dim0;
	}, ';border-bottom:2px solid ', function (props) {
	  return props.theme.set.light.highlight;
	}, ';&:hover{color:black;border-bottom:2px solid ', function (props) {
	  return props.theme.colors.warm.base;
	}, ';/*\n      border-bottom:2px solid ', function (props) {
	  return props.theme.set.light.highlight;
	}, ';*/}}.headroom--unpinned{', HeadroomWrapDiv, '{height:0px;}', LinkNav, '{border-bottom:2px solid transparent;}}.headroom--pinned{box-shadow:', function (props) {
	  return props.theme.set.light.shadow.feature.small.main;
	}, ';background-color:', function (props) {
	  return props.theme.set.light.bgHeadroom;
	}, ';svg{g{fill:', function (props) {
	  return props.theme.set.light.highlight;
	}, ';}}', LinkNav, '{border-bottom:2px solid transparent;color:', function (props) {
	  return props.theme.set.light.placeholder;
	}, ';text-shadow:0.25rem 0.2rem 0.25rem rgba(0,0,0,1),', function (props) {
	  return props.theme.set.light.shadow._3dThinCool;
	}, ';&:focus{border-bottom:2px solid transparent;color:', function (props) {
	  return props.theme.colors.pure.white;
	}, ';text-shadow:0.25rem 0.2rem 0.25rem rgba(0,0,0,1),', function (props) {
	  return props.theme.set.light.shadow._3dThinCool;
	}, ';svg{g{fill:', function (props) {
	  return props.theme.set.dark.highlight;
	}, ';}}}&:hover{border-bottom:2px solid ', function (props) {
	  return props.theme.set.light.highlight;
	}, ';color:', function (props) {
	  return props.theme.colors.pure.white;
	}, ';/*\n        text-shadow:0.5rem 0.2rem 0.5rem rgba(0,0,0,1),1px 0px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ',0px 1px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ',1px 1px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ';*/\n        text-shadow:0.25rem 0.2rem 0.25rem rgba(0,0,0,1),', function (props) {
	  return props.theme.set.light.shadow._3dThinCool;
	}, ';svg{g{fill:', function (props) {
	  return props.theme.set.dark.highlight;
	}, ';}}}}', LinkLogo, '{color:', function (props) {
	  return props.theme.set.light.placeholder;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThinCool;
	}, ',', function (props) {
	  return props.theme.set.light.shadow._3dThinCool;
	}, ';&:focus,&:hover{color:', function (props) {
	  return props.theme.set.dark.p;
	}, ';text-shadow:0rem 0.3rem 0.5rem rgba(0,0,0,0.45),-1px -1px 0 ', function (props) {
	  return props.theme.set.light.p;
	}, ',1px -1px 0 ', function (props) {
	  return props.theme.set.light.p;
	}, ',-1px 1px 0 ', function (props) {
	  return props.theme.set.light.p;
	}, ',1px 1px 0 ', function (props) {
	  return props.theme.set.light.p;
	}, ';}}', TriLink, '{&:focus,&:hover{border-bottom:2px solid transparent;}}}');
	
	var path = '#';
	var pathFix = '';
	var scrollY = 0;
	var scrollX = 0;
	// let theme.lastNavOnId = '';
	
	var setOpacity = function setOpacity(arr, len, opacity) {
	  var i = 0;
	  for (; i < len; i++) {
	    arr[i].style.opacity = opacity;
	  }
	};
	
	var regex = {
	  // logoPath: /\/ $/,
	  productPath: /\/product\s|\/product\/\s/,
	  newsPath: /\/news\s|\/news\/\s/,
	  helpPath: /\/help\s|\/help\/\s/
	};
	var toggleDisplay = function toggleDisplay() {
	  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'HeadroomWrapDiv';
	  var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
	
	  document.getElementById(id).style.display = display;
	  // document.getElementById('HeadroomWrapDiv').style.display = 'none';
	};
	var upNav = function upNav() {
	  if (_theme.theme.lastNavOnId !== '') {
	    document.getElementById(_theme.theme.lastNavOnId).style = _theme.theme.cssNav;
	  }
	};
	var handleSubmit = function handleSubmit(e) {
	  if (scrollX !== window.pageXOffset) {
	    scrollX = window.pageXOffset;
	  }
	  if (scrollY !== window.pageYOffset) {
	    scrollY = window.pageYOffset;
	  }
	  // force scroll back after page load:
	  if (typeof setTimeout !== 'undefined') {
	    setTimeout(function () {
	      window.scroll(scrollX, scrollY);
	    }, 0);
	  }
	  var orbWrapElements = document.getElementsByClassName(_theme.theme.set.mode.toLowerCase() + 'OrbWrap');
	  var orbWrapElementsLen = orbWrapElements.length;
	  setOpacity(orbWrapElements, orbWrapElementsLen, 0);
	
	  (0, _theme.setMode)();
	  if (_theme.theme.set.mode === 'Light') {
	    document.getElementById('LightIcon').style.opacity = 0.0;
	    document.getElementById('DarkIcon').style.opacity = 0.7;
	  } else {
	    document.getElementById('LightIcon').style.opacity = 0.7;
	    document.getElementById('DarkIcon').style.opacity = 0.0;
	  }
	
	  orbWrapElements = document.getElementsByClassName(_theme.theme.set.mode.toLowerCase() + 'OrbWrap');
	  setOpacity(orbWrapElements, orbWrapElementsLen, 1);
	
	  setTimeout(upNav, 0);
	  (0, _OrbContainer.openOrbContainer)();
	};
	var doNav = function doNav() {
	  if (pathFix === '/ ') {
	    if (_theme.theme.lastNavOnId === 'LinkLogo') {
	      return;
	    }
	    document.getElementById('LinkLogo').style = _theme.theme.cssNav;
	    document.getElementById(_theme.theme.lastNavOnId).style = '';
	    _theme.theme.lastNavOnId = 'LinkLogo';
	    return;
	  }
	  if (regex.productPath.test(pathFix)) {
	    if (_theme.theme.lastNavOnId === 'LinkProduct') {
	      return;
	    }
	    document.getElementById('LinkProduct').style = _theme.theme.cssNav;
	    document.getElementById(_theme.theme.lastNavOnId).style = '';
	    _theme.theme.lastNavOnId = 'LinkProduct';
	    return;
	  }
	  if (regex.newsPath.test(pathFix)) {
	    if (_theme.theme.lastNavOnId === 'LinkNews') {
	      return;
	    }
	    document.getElementById('LinkNews').style = _theme.theme.cssNav;
	    document.getElementById(_theme.theme.lastNavOnId).style = '';
	    _theme.theme.lastNavOnId = 'LinkNews';
	    return;
	  }
	  if (regex.helpPath.test(pathFix)) {
	    if (_theme.theme.lastNavOnId === 'LinkHelp') {
	      return;
	    }
	    document.getElementById('LinkHelp').style = _theme.theme.cssNav;
	    document.getElementById(_theme.theme.lastNavOnId).style = '';
	    _theme.theme.lastNavOnId = 'LinkHelp';
	    return;
	  }
	  document.getElementById(_theme.theme.lastNavOnId).style = '';
	  _theme.theme.lastNavOnId = '';
	};
	var initNav = function initNav() {
	  if (_theme.theme.lastNavOnId !== '') {
	    setTimeout(doNav, 0);
	    return;
	  }
	  if (pathFix === '/ ') {
	    document.getElementById('LinkLogo').style = _theme.theme.cssNav;
	    _theme.theme.lastNavOnId = 'LinkLogo';
	    return;
	  }
	  if (regex.productPath.test(pathFix)) {
	    document.getElementById('LinkProduct').style = _theme.theme.cssNav;
	    _theme.theme.lastNavOnId = 'LinkProduct';
	    return;
	  }
	  if (regex.newsPath.test(pathFix)) {
	    document.getElementById('LinkNews').style = _theme.theme.cssNav;
	    _theme.theme.lastNavOnId = 'LinkNews';
	    return;
	  }
	  if (regex.helpPath.test(pathFix)) {
	    document.getElementById('LinkHelp').style = _theme.theme.cssNav;
	    _theme.theme.lastNavOnId = 'LinkHelp';
	  }
	};
	
	var Navigation = function Navigation() {
	  if (typeof window !== 'undefined') {
	    path = window.location.pathname;
	  }
	
	  pathFix = path + ' ';
	  // alert(pathFix);
	  setTimeout(initNav, 0);
	  //  Only return if not an iframe:
	  if (typeof window !== 'undefined') {
	    if (window.parent.location === self.location) {
	
	      setTimeout(function () {
	        if (_theme.theme.set.mode === 'Light') {
	          document.getElementById('LightIcon').style.opacity = 0.0;
	          document.getElementById('DarkIcon').style.opacity = 0.7;
	        } else {
	          document.getElementById('LightIcon').style.opacity = 0.7;
	          document.getElementById('DarkIcon').style.opacity = 0.0;
	        }
	      }, 1);
	
	      return _react2.default.createElement(
	        HeadroomWrapDiv,
	        { id: 'HeadroomWrapDiv' },
	        _react2.default.createElement(
	          HeadRoom,
	          { calcHeightOnResize: true, disableInlineStyles: true },
	          _react2.default.createElement(
	            HeadroomDiv,
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'inline', width: '100%' } },
	              _react2.default.createElement(
	                LinkLogo,
	                { to: '/', id: 'LinkLogo' },
	                'SONDROS'
	              ),
	              _react2.default.createElement(
	                Nav,
	                null,
	                _react2.default.createElement(
	                  TriLink,
	                  { to: path, onClick: function onClick(e) {
	                      return handleSubmit(e);
	                    } },
	                  _react2.default.createElement(_DarkIcon2.default, null),
	                  _react2.default.createElement(_LightIcon2.default, null),
	                  _react2.default.createElement(Tri, null),
	                  _react2.default.createElement(BgTri, null),
	                  _react2.default.createElement(ShadowTri, null)
	                ),
	                _react2.default.createElement(
	                  LinkNav,
	                  { id: 'LinkHelp', to: '/help', activeClassName: 'active' },
	                  _react2.default.createElement(_HandsHelping2.default, null),
	                  _react2.default.createElement(
	                    InlineBlockDiv,
	                    null,
	                    ':' + '\xA0' + '.' + '\xA0' + 'HELP'
	                  )
	                ),
	                _react2.default.createElement(
	                  LinkNav,
	                  { id: 'LinkNews', to: '/news', activeClassName: 'active' },
	                  _react2.default.createElement(_History2.default, null),
	                  _react2.default.createElement(
	                    InlineBlockDiv,
	                    null,
	                    ':' + '\xA0' + '.' + '\xA0' + 'NEWS'
	                  )
	                ),
	                _react2.default.createElement(
	                  LinkNav,
	                  { id: 'LinkProduct', to: '/product', activeClassName: 'active' },
	                  _react2.default.createElement(_Trophy2.default, null),
	                  _react2.default.createElement(
	                    InlineBlockDiv,
	                    null,
	                    ':' + '\xA0' + '.' + '\xA0' + 'PRODUCT'
	                  )
	                )
	              ),
	              _react2.default.createElement(_OrbContainer.OrbContainer, null)
	            )
	          )
	        )
	      );
	    } else {
	      // alert('app');
	      return _react2.default.createElement('div', null);
	    }
	  }
	  return _react2.default.createElement('div', null);
	};
	exports.default = Navigation;
	// paddingRight: "4rem",
	
	module.exports = exports['default'];

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.lastOrbOn = exports.Orb = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _theme = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { initOrbOn } from './OrbContainer';
	
	var OrbWrap = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'efbiu2u0'
	})('width:5rem;height:5.5rem;');
	
	var LightOrbShadow = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'efbiu2u1'
	})('position:relative;top:-6.38rem;width:4rem;height:0.8rem;border-radius:50%;overflow:hidden;background:radial-gradient(50% 20%,rgba(0,0,0,0.85) 100%,rgba(0,0,0,0.85) 0%);');
	
	var DarkOrbShadow = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'efbiu2u2'
	})('position:relative;top:-17.92rem;width:4rem;height:0.8rem;border-radius:50%;overflow:hidden;background:radial-gradient(50% 20%,rgba(0,0,0,0.85) 100%,rgba(0,0,0,0.85) 0%);');
	
	var OrbDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'efbiu2u3'
	})('position:relative;display:inline-block;z-index:3;width:5rem;height:5rem;border-radius:50%;transition:all 0.25s;');
	
	var DarkOrbWrap = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'efbiu2u4'
	})('opacity:0;transition:all 0.25s;');
	
	var LightOrbWrap = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'efbiu2u5'
	})('opacity:1;transition:all 0.25s;');
	// custom: cyan, purple, magenta
	
	var moodLightClass = '';
	var moodDarkClass = '';
	var lightClass = '';
	var darkClass = '';
	
	// let nowPreviewColors = {};
	var len = 3;
	var hslI = [4, 8, 13];
	var init = false;
	var path = '';
	var totalObjs = 0;
	var scrollY = 0;
	var scrollX = 0;
	var color = ['cyan', 'purple', 'magenta'];
	var lightOpacity = 0;
	var id = '';
	var lastOrbOn = '';
	// const defaultColor = [
	//   `${previewColors.cool.light_main}`,
	//   `${previewColors.cool.light_shadow}`,
	//   `${previewColors.warm.light_glow}`,
	//   `${previewColors.cool.dark_main}`,
	//   `${previewColors.cool.dark_shadow}`,
	//   `${previewColors.warm.dark_glow}`,
	// ];
	var defaultColor = ['', '', '', '', '', ''];
	
	var oldMode = '';
	
	var orbClick = function orbClick(mood) {
	  if (mood !== null) {
	    if (scrollX !== window.pageXOffset) {
	      scrollX = window.pageXOffset;
	    }
	    if (scrollY !== window.pageYOffset) {
	      scrollY = window.pageYOffset;
	    }
	    // Force scroll back after page load:
	    if (typeof setTimeout !== 'undefined') {
	      setTimeout(function () {
	        window.scroll(scrollX, scrollY);
	      }, 0);
	    }
	
	    // Reset stored theme of orb
	    if (_theme.theme.set.id !== 'Default' && !init) {
	      document.getElementById('' + _theme.theme.set.mode.toLowerCase() + _theme.theme.set.id).style.opacity = 0;
	      document.getElementById('mood' + _theme.theme.set.mode + _theme.theme.set.id).style.opacity = 1;
	
	      init = true;
	    }
	
	    oldMode = _theme.theme.set.mode;
	
	    if (mood.id === _theme.theme.set.id && _theme.theme.set.id !== 'Default') {
	      (0, _theme.updateColors)(_theme.theme);
	
	      if (document.getElementById(_theme.theme.lastNavOnId) !== null) {
	        _theme.theme.cssNav = '\n        color: white; \n        text-shadow: 0.25rem 0.2rem 0.5rem black,\n        -1px -1px 0 ' + _theme.theme.colors.fire.light + ', \n        -1px 1px 0 ' + _theme.theme.colors.fire.light + ', \n        -1px 1px 0 ' + _theme.theme.colors.fire.light + ',\n        0px 1px 0 ' + _theme.theme.colors.fire.light + ',\n        1px -1px 0 ' + _theme.theme.colors.fire.light + ',  \n        1px 0px 0 ' + _theme.theme.colors.fire.light + ', \n        1px 1px 0 ' + _theme.theme.colors.fire.light + ';\n        ';
	
	        document.getElementById(_theme.theme.lastNavOnId).style = _theme.theme.cssNav;
	      }
	      document.getElementById('moodDark' + mood.id).style.opacity = 1;
	      document.getElementById('moodLight' + mood.id).style.opacity = 1;
	      _theme.theme.set.id = 'Default';
	      document.getElementById('dark' + mood.id).style.opacity = 0;
	      document.getElementById('light' + mood.id).style.opacity = 0;
	      if (oldMode === 'Dark') {
	        (0, _theme.updateSet)(_theme.theme);
	        (0, _theme.setMode)('Dark');
	        return;
	      }
	      (0, _theme.updateSet)(_theme.theme);
	      return;
	    }
	    if (_theme.theme.set.id !== 'Default') {
	      (0, _theme.updateColors)(_theme.theme);
	      _theme.theme.set.id = 'Default';
	      if (oldMode === 'Dark') {
	        (0, _theme.setMood)(_theme.theme, mood);
	        (0, _theme.setMode)('Dark');
	      } else {
	        (0, _theme.setMood)(_theme.theme, mood);
	      }
	    } else if (oldMode === 'Dark') {
	      (0, _theme.setMood)(_theme.theme, mood);
	      (0, _theme.setMode)('Dark');
	    } else {
	      (0, _theme.setMood)(_theme.theme, mood);
	    }
	
	    // alert(`#5# ${theme.set.mode} old:${oldMode}`);
	
	    if (lastOrbOn !== '') {
	      document.getElementById('moodDark' + lastOrbOn).style.opacity = 1;
	      document.getElementById('moodLight' + lastOrbOn).style.opacity = 1;
	      document.getElementById('dark' + lastOrbOn).style.opacity = 0;
	      document.getElementById('light' + lastOrbOn).style.opacity = 0;
	    }
	
	    document.getElementById('moodDark' + mood.id).style.opacity = 0;
	    document.getElementById('moodLight' + mood.id).style.opacity = 0;
	
	    document.getElementById('dark' + mood.id).style.opacity = 1;
	    document.getElementById('light' + mood.id).style.opacity = 1;
	
	    exports.lastOrbOn = lastOrbOn = '' + mood.id;
	  }
	};
	
	var OrbLink = /*#__PURE__*/(0, _reactEmotion2.default)(_gatsbyLink2.default, {
	  target: 'efbiu2u6'
	})('position:absolute;overflow:hidden;height:6.5rem;width:6rem;padding-top:0.5rem;&:focus,&:hover{', OrbDiv, '{width:5.26rem;height:5.26rem;}', LightOrbShadow, '{width:4.26rem;height:1.06rem;}', DarkOrbShadow, '{width:4.26rem;height:1.06rem;}.darkClass{display:grid;top:-11.65rem;}.lightClass{display:grid;top:-0.15rem;}}');
	
	var Orb = function Orb(_ref) {
	  var _ref$mood = _ref.mood,
	      mood = _ref$mood === undefined ? null : _ref$mood,
	      type = _ref.type;
	
	  /*
	  const copy = (val) => {return [...val];};
	  const structuredClone = obj => {
	    const oldState = history.state;
	    history.replaceState(obj, null);
	    const clonedObj = history.state;
	    history.replaceState(oldState, null);
	    return clonedObj;
	  };
	  */
	
	  if (type !== 'mod') {
	    if (mood === null) {
	      color[0] = '' + _theme.previewColors.cool.light_main;
	      color[1] = '' + _theme.previewColors.cool.light_shadow;
	      color[2] = '' + _theme.previewColors.warm.light_glow;
	      color[3] = '' + _theme.previewColors.cool.dark_main;
	      color[4] = '' + _theme.previewColors.cool.dark_shadow;
	      color[5] = '' + _theme.previewColors.warm.dark_glow;
	    } else {
	      var nowPreviewColors = new _theme.previewColors();
	      defaultColor[0] = '' + nowPreviewColors.cool.light_main;
	      defaultColor[1] = '' + nowPreviewColors.cool.light_shadow;
	      defaultColor[2] = '' + nowPreviewColors.warm.light_glow;
	      defaultColor[3] = '' + nowPreviewColors.cool.dark_main;
	      defaultColor[4] = '' + nowPreviewColors.cool.dark_shadow;
	      defaultColor[5] = '' + nowPreviewColors.warm.dark_glow;
	
	      //nowPreviewColors = JSON.parse(JSON.stringify(previewColors));
	
	      // alert(nowPreviewColors.cool.light_main);
	      // alert(mood.id);
	      nowPreviewColors.cool = (0, _theme.getColor)(hslI, len, nowPreviewColors.cool, mood.hslCool);
	      nowPreviewColors.warm = (0, _theme.getColor)(hslI, len, nowPreviewColors.warm, mood.hslWarm);
	
	      color[0] = '' + nowPreviewColors.cool.light_main;
	      color[1] = '' + nowPreviewColors.cool.light_shadow;
	      color[2] = '' + nowPreviewColors.warm.light_glow;
	      color[3] = '' + nowPreviewColors.cool.dark_main;
	      color[4] = '' + nowPreviewColors.cool.dark_shadow;
	      color[5] = '' + nowPreviewColors.warm.dark_glow;
	    }
	  } else {
	    lightOpacity = 1;
	    color = ['cyan', 'purple', 'magenta'];
	  }
	
	  // alert(color[0]);
	  darkClass = '\n    opacity: 0;\n    top: -11.6rem;\n    background: radial-gradient(\n      circle at 65% 15%, \n      white 0.1225rem, \n      ' + defaultColor[3] + ' 5%, \n      ' + defaultColor[4] + ' 60%, \n      ' + defaultColor[5] + ' 82%\n      );\n      &:focus,\n      &:hover {\n      } \n  ';
	
	  moodDarkClass = '\n    top: -16.9rem;\n    background: radial-gradient(\n      circle at 65% 15%, \n      white 0.1225rem, \n      ' + color[3] + ' 5%, \n      ' + color[4] + ' 60%, \n      ' + color[5] + ' 82%\n      ); \n      &:focus,\n      &:hover {\n      } \n  ';
	
	  lightClass = '\n    opacity: 0;\n    background: radial-gradient(\n      circle at 65% 15%, \n      white 0.1225rem, \n      ' + defaultColor[0] + ' 5%, \n      ' + defaultColor[1] + ' 60%, \n      ' + defaultColor[2] + ' 82%\n      );\n      &:focus,\n      &:hover {\n      } \n  ';
	
	  moodLightClass = '\n    left: 0rem;\n    top: -5.4rem;\n    opacity: 1;\n    background: radial-gradient(\n      circle at 65% 15%, \n      white 0.1225rem, \n      ' + color[0] + ' 5%, \n      ' + color[1] + ' 60%, \n      ' + color[2] + ' 82%\n      )\n  ';
	
	  // ${props => props.theme.colors.cool.coal}
	  if (typeof window !== 'undefined') {
	    path = window.location.pathname;
	  }
	  if (mood !== null) {
	    id = '' + mood.id;
	  }
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      OrbWrap,
	      null,
	      _react2.default.createElement(
	        OrbLink,
	        { id: 'orb' + id, to: path, onClick: function onClick(e) {
	            return orbClick(mood);
	          } },
	        _react2.default.createElement(
	          LightOrbWrap,
	          { className: 'lightOrbWrap' },
	          _react2.default.createElement(OrbDiv, { id: 'light' + id, className: /*#__PURE__*/(0, _reactEmotion.css)(lightClass) + ' lightClass' }),
	          _react2.default.createElement(OrbDiv, { id: 'moodLight' + id, className: /*#__PURE__*/ /*#__PURE__*/(0, _reactEmotion.css)(moodLightClass) }),
	          _react2.default.createElement(LightOrbShadow, null)
	        ),
	        _react2.default.createElement(
	          DarkOrbWrap,
	          { className: 'darkOrbWrap' },
	          _react2.default.createElement(OrbDiv, { id: 'dark' + id, className: /*#__PURE__*/(0, _reactEmotion.css)(darkClass) + ' darkClass' }),
	          _react2.default.createElement(OrbDiv, { id: 'moodDark' + id, className: /*#__PURE__*/ /*#__PURE__*/(0, _reactEmotion.css)(moodDarkClass) }),
	          _react2.default.createElement(DarkOrbShadow, null)
	        )
	      )
	    )
	  );
	};
	
	exports.Orb = Orb;
	exports.lastOrbOn = lastOrbOn;
	
	
	Orb.propTypes = {
	  mood: _propTypes2.default.object,
	  type: _propTypes2.default.string
	};
	
	Orb.defaultProps = {
	  type: 'mood',
	  mood: null
	};

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.setTheme = exports.openOrbContainer = exports.OrbContainer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _kebabCase = __webpack_require__(33);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _theme = __webpack_require__(14);
	
	var _Orb = __webpack_require__(281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrbHolderDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1xytin60'
	})('transition:all 0.65s;display:grid;position:absolute;width:100%;max-width:', function (props) {
	  return props.theme.layout.max;
	}, ';box-shadow:', function (props) {
	  return props.theme.set.light.shadow.feature.small.main;
	}, ';border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';background-image:linear-gradient(360deg,rgba(0,0,0,0.75) 0%,rgba(0,0,0,0) 75%);transform:translateY(-24rem);justify-items:end;margin-left:-1.5rem;scrolling:no;top:3rem;@media (min-width:', function (props) {
	  return props.theme.layout.max;
	}, '){margin-left:0.75rem;padding:0;}@media (max-width:675px){top:6rem;}');
	
	var OrbContainerDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1xytin61'
	})('height:14.5rem;padding-top:1rem;padding-bottom:1rem;margin-bottom:1rem;padding-left:0.5rem;padding-right:0.5rem;display:grid;grid-template-columns:repeat(5,1fr);grid-column-gap:1rem;grid-row-gap:2rem;@media (max-width:500px){width:100%;}@media (max-width:675px){margin-top:-2rem;}');
	
	var OrbH2 = /*#__PURE__*/(0, _reactEmotion2.default)('h2', {
	  target: 'e1xytin62'
	})('font-size:1rem;margin-right:1.5rem;margin-bottom:-0.05rem;color:', function (props) {
	  return props.theme.colors.pure.white;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThin;
	}, ';');
	
	var RedX = /*#__PURE__*/(0, _reactEmotion2.default)('h2', {
	  target: 'e1xytin63'
	})('color:darkred;font-size:5rem;max-height:3rem;transition:all 0.25s;padding-top:0.5rem;padding-left:0.25rem;text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThin;
	}, ';&:focus,&:hover{color:red;cursor:pointer;font-size:6rem;padding:0;}');
	
	var OverflowDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1xytin64'
	})('height:0;width:100%;overflow:hidden;transition:all 4s;');
	
	var storedTheme = '';
	var orbsInited = false;
	var unthemed = true;
	
	var mediaType_S = '(prefers-color-scheme: dark)';
	
	var setTheme = function setTheme() {
	  if (!unthemed) {
	    return;
	  }
	
	  // alert(`
	  //   ${storedTheme} ${theme.set.id}
	  //   ${localStorage.getItem('mood')}
	  //   ${theme.set.mode} ${localStorage.getItem('mode')}
	  //   `);
	
	  // Debug force init:
	  // localStorage.setItem('mood', `Vampire`);
	  // localStorage.setItem('mode', `Light`);
	  // storedTheme = localStorage.getItem('mood');
	  // orbClick2(theme.colors.mood[`${storedTheme.toLowerCase()}`]);
	  // return;
	
	  if (typeof Storage !== 'undefined' && localStorage !== null) {
	    if (localStorage.getItem('mood') !== null && localStorage.getItem('mood') !== 'Default') {
	      storedTheme = localStorage.getItem('mood');
	      (0, _theme.setMood)(_theme.theme, _theme.theme.colors.mood['' + storedTheme.toLowerCase()]);
	    } else if (typeof window !== 'undefined' && localStorage.getItem('mode') !== 'Dark') {
	      if (window.matchMedia(mediaType_S).media !== mediaType_S || window.matchMedia(mediaType_S).matches) {
	        (0, _theme.setMood)(_theme.theme, _theme.theme.colors.mood['graphene']);
	        (0, _theme.setMode)('Dark');
	      } else if (localStorage.getItem('mood') !== 'Default') {
	        (0, _theme.setMood)(_theme.theme, _theme.theme.colors.mood['spartan']);
	        (0, _theme.setMode)('Light');
	      }
	    }
	    //alert(`mode: ${localStorage.getItem('mode')}`);
	
	    if (localStorage.getItem('mode') === 'Dark') {
	      (0, _theme.setMode)(localStorage.getItem('mode'));
	      // alert(localStorage.getItem('mode'));
	    }
	  }
	
	  unthemed = false;
	};
	
	var closeOrbContainer = function closeOrbContainer() {
	  if (document.getElementById('OrbHolderDiv').style.transform !== 'translateY(-24rem)') {
	    document.getElementById('OrbHolderDiv').style.transform = 'translateY(-24rem)';
	  }
	  if (typeof Storage !== 'undefined') {
	    localStorage.setItem('mood', '' + _theme.theme.set.id);
	    localStorage.setItem('mode', '' + _theme.theme.set.mode);
	    // alert(`set: ${theme.set.id} ${localStorage.getItem('mood')}`);
	  }
	};
	
	var openOrbContainer = function openOrbContainer() {
	  if (document.getElementById('OrbHolderDiv').style.transform !== 'translateY(1.5rem)') {
	    document.getElementById('OrbHolderDiv').style.transform = 'translateY(1.5rem)';
	  }
	  if (!orbsInited) {
	    // alert(`mood${theme.set.mode}${theme.set.id} ${theme.set.mode.toLowerCase()}${theme.set.id}`);
	    if (_theme.theme.set.id !== 'Default') {
	      document.getElementById('mood' + _theme.theme.set.mode + _theme.theme.set.id).style.opacity = 0;
	      document.getElementById('' + _theme.theme.set.mode.toLowerCase() + _theme.theme.set.id).style.opacity = 1;
	      orbsInited = true;
	    }
	  }
	};
	
	var OrbContainer = function OrbContainer(_ref) {
	  var type = _ref.type,
	      mood = _ref.mood;
	
	  // ${props => props.theme.colors.cool.coal}
	  var i = 0;
	  return _react2.default.createElement(
	    OverflowDiv,
	    { id: 'OverflowDiv' },
	    _react2.default.createElement(
	      OrbHolderDiv,
	      { id: 'OrbHolderDiv' },
	      _react2.default.createElement(
	        OrbContainerDiv,
	        null,
	        _react2.default.createElement(_Orb.Orb, { mood: _theme.theme.colors.mood.lotus }),
	        _react2.default.createElement(_Orb.Orb, { mood: _theme.theme.colors.mood.sequoia }),
	        _react2.default.createElement(_Orb.Orb, { mood: _theme.theme.colors.mood.ivy }),
	        _react2.default.createElement(_Orb.Orb, { mood: _theme.theme.colors.mood.graphene }),
	        _react2.default.createElement(
	          RedX,
	          { onClick: function onClick(e) {
	              return closeOrbContainer();
	            } },
	          'X'
	        ),
	        _react2.default.createElement(_Orb.Orb, { mood: _theme.theme.colors.mood.lagoon }),
	        _react2.default.createElement(_Orb.Orb, { mood: _theme.theme.colors.mood.orchid }),
	        _react2.default.createElement(_Orb.Orb, { mood: _theme.theme.colors.mood.vampire }),
	        _react2.default.createElement(_Orb.Orb, { mood: _theme.theme.colors.mood.spartan }),
	        _react2.default.createElement('div', null)
	      ),
	      _react2.default.createElement(
	        OrbH2,
	        null,
	        _theme.theme.set.id,
	        ' [ ',
	        _theme.theme.set.mode,
	        ' ]'
	      )
	    )
	  );
	};
	exports.OrbContainer = OrbContainer;
	exports.openOrbContainer = openOrbContainer;
	exports.setTheme = setTheme;
	
	
	OrbContainer.propTypes = {
	  mood: _propTypes2.default.array,
	  type: _propTypes2.default.string
	};
	
	OrbContainer.defaultProps = {
	  type: 'mood'
	};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _website = __webpack_require__(8);
	
	var _website2 = _interopRequireDefault(_website);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEO = function SEO(props) {
	  var postNode = props.postNode,
	      postPath = props.postPath,
	      postSEO = props.postSEO;
	
	  var title = void 0;
	  var description = void 0;
	  var image = void 0;
	  var postURL = void 0;
	  if (postSEO) {
	    var postMeta = postNode.frontmatter;
	    title = postMeta.title; // eslint-disable-line prefer-destructuring
	    description = postNode.excerpt;
	    image = postMeta.cover.childImageSharp.resize.src;
	    postURL = _website2.default.siteUrl + _website2.default.pathPrefix + postPath;
	  } else {
	    title = _website2.default.siteTitle;
	    description = _website2.default.siteDescription;
	    image = _website2.default.siteBanner;
	  }
	  var realPrefix = _website2.default.pathPrefix === "/" ? "" : _website2.default.pathPrefix;
	  image = _website2.default.siteUrl + realPrefix + image;
	  var newsURL = _website2.default.siteUrl + _website2.default.pathPrefix;
	  var schemaOrgJSONLD = [{
	    "@context": "http://schema.org",
	    "@type": "WebSite",
	    url: newsURL,
	    name: title,
	    alternateName: _website2.default.siteTitleAlt ? _website2.default.siteTitleAlt : ""
	  }];
	  if (postSEO) {
	    schemaOrgJSONLD.push([{
	      "@context": "http://schema.org",
	      "@type": "BreadcrumbList",
	      itemListElement: [{
	        "@type": "ListItem",
	        position: 1,
	        item: {
	          "@id": postURL,
	          name: title,
	          image: image
	        }
	      }]
	    }, {
	      "@context": "http://schema.org",
	      "@type": "newsPosting",
	      url: newsURL,
	      name: title,
	      alternateName: _website2.default.siteTitleAlt,
	      headline: title,
	      image: {
	        "@type": "ImageObject",
	        url: image
	      },
	      description: description
	    }]);
	  }
	  return _react2.default.createElement(
	    _reactHelmet2.default,
	    null,
	    _react2.default.createElement("html", { lang: "en" }),
	    _react2.default.createElement(
	      "title",
	      null,
	      title
	    ),
	    _react2.default.createElement("meta", { name: "description", content: description }),
	    _react2.default.createElement("meta", { name: "image", content: image }),
	    _react2.default.createElement("meta", { charSet: "utf-8" }),
	    _react2.default.createElement("meta", { httpEquiv: "X-UA-Compatible", content: "IE=edge,chrome=1" }),
	    _react2.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
	    _react2.default.createElement("link", {
	      rel: "apple-touch-icon",
	      sizes: "180x180",
	      href: "/favicons/apple-touch-icon.png"
	    }),
	    _react2.default.createElement("link", {
	      rel: "icon",
	      type: "image/png",
	      sizes: "32x32",
	      href: "/favicons/favicon-32x32.png"
	    }),
	    _react2.default.createElement("link", {
	      rel: "icon",
	      type: "image/png",
	      sizes: "16x16",
	      href: "/favicons/favicon-16x16.png"
	    }),
	    _react2.default.createElement("link", {
	      rel: "mask-icon",
	      href: "/favicons/safari-pinned-tab.svg",
	      color: "#343849"
	    }),
	    _react2.default.createElement("meta", { name: "apple-mobile-web-app-title", content: "Sondro" }),
	    _react2.default.createElement("meta", { name: "application-name", content: "Sondro" }),
	    _react2.default.createElement("meta", { name: "msapplication-TileColor", content: "#3498db" }),
	    _react2.default.createElement(
	      "script",
	      { type: "application/ld+json" },
	      JSON.stringify(schemaOrgJSONLD)
	    ),
	    _react2.default.createElement("meta", { property: "og:locale", content: "us_EN" }),
	    _react2.default.createElement("meta", { property: "og:site_name", content: _website2.default.facebook }),
	    _react2.default.createElement("meta", { property: "og:url", content: postSEO ? postURL : newsURL }),
	    postSEO ? _react2.default.createElement("meta", { property: "og:type", content: "article" }) : null,
	    _react2.default.createElement("meta", { property: "og:title", content: title }),
	    _react2.default.createElement("meta", { property: "og:description", content: description }),
	    _react2.default.createElement("meta", { property: "og:image", content: image }),
	    _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
	    _react2.default.createElement("meta", { name: "twitter:creator", content: _website2.default.twitter }),
	    _react2.default.createElement("meta", { name: "twitter:title", content: title }),
	    _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	    _react2.default.createElement("meta", { name: "twitter:image", content: image })
	  );
	};
	
	exports.default = SEO;
	
	
	SEO.propTypes = {
	  postNode: _propTypes2.default.object,
	  postPath: _propTypes2.default.string,
	  postSEO: _propTypes2.default.bool
	};
	module.exports = exports["default"];

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Triangle = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1314wrb0'
	})('position:relative;background-color:orange;text-align:left;font-size:1rem;&:before,&:after{content:\'\';position:absolute;background-color:inherit;}width:10em;height:10em;&:before,&:after{width:10em;height:10em;border-top-right-radius:30%;}transform:rotate(-60deg) skewX(-30deg) scale(1,0.866);&:before{transform:rotate(-135deg) skewX(-45deg) scale(1.414,0.707) translate(0,-50%);}&:after{transform:rotate(135deg) skewY(-45deg) scale(0.707,1.414) translate(50%);}');
	
	exports.default = Triangle;
	module.exports = exports['default'];

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HandsHelping = function HandsHelping() {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 644 524" },
	    _react2.default.createElement(
	      "g",
	      null,
	      _react2.default.createElement("path", { d: "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z" })
	    )
	  );
	};
	
	exports.default = HandsHelping;
	module.exports = exports["default"];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var History = function History() {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
	    _react2.default.createElement(
	      "g",
	      null,
	      _react2.default.createElement("path", { d: "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z" })
	    )
	  );
	};
	
	exports.default = History;
	module.exports = exports["default"];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _path = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Trophy = function Trophy() {
	  return _react2.default.createElement(
	    'svg',
	    {
	      preserveAspectRatio: 'xMidYMid meet',
	      viewBox: '0 0 580 528',
	      style: { position: 'relative', left: '0.25rem', top: '0.1rem' }
	    },
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('path', { d: 'M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z' })
	    )
	  );
	};
	
	exports.default = Trophy;
	
	/*
	      paddingTop: '0.039rem',
	    viewBox="0 0 580 528"
	    style={{
	      position: 'relative',
	      left: '0.25rem',
	      top: '0.056rem',
	      marginTop: '-0.015',
	      paddingLeft: '0.2rem',
	    }}
	  viewBox="-5 -8 584 528"
	    style={{ position: 'relative', left: '0.07rem', top: '0.056rem', marginLeft: '0rem' }}
	    viewBox="0 0 580 528"
	    style={{ position: 'relative', left: '0.25rem', top: '0.1rem', marginLeft: '0rem' }}

	*/

	module.exports = exports['default'];

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DarkIconDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e437nuq0'
	})('z-index:999;position:absolute;top:-12px;right:-15px;font-size:28px;transform:rotate(-20deg);opacity:0.0;transition:opacity 0.4s;');
	
	var DarkIcon = function DarkIcon() {
	  return _react2.default.createElement(
	    DarkIconDiv,
	    { id: 'DarkIcon' },
	    _react2.default.createElement(
	      'svg',
	      {
	        preserveAspectRatio: 'xMidYMid meet',
	        height: '1em',
	        width: '1em',
	        viewBox: '0 0 384 512',
	        style: { verticalAlign: "middle", marginRight: "0.5rem" }
	      },
	      _react2.default.createElement(
	        'g',
	        { style: { stroke: "black",
	            fill: "`${props => props.theme.colors.warm.base}",
	            strokeWidth: "26px" } },
	        _react2.default.createElement('path', { d: 'M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z' })
	      )
	    )
	  );
	};
	exports.default = DarkIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LightIconDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'exlr6ao0'
	})('z-index:999;position:absolute;top:-46px;right:-32px;font-size:68px;opacity:0.0;transition:opacity 0.4s;');
	
	var LightIcon = function LightIcon() {
	  return _react2.default.createElement(
	    LightIconDiv,
	    { id: 'LightIcon' },
	    _react2.default.createElement(
	      'svg',
	      {
	        preserveAspectRatio: 'xMidYMid meet',
	        height: '1em',
	        width: '1em',
	        viewBox: '0 0 576 576',
	        style: { verticalAlign: "middle", marginRight: "0.5rem" } },
	      _react2.default.createElement(
	        'g',
	        { style: { stroke: "black",
	            fill: "`${props => props.theme.colors.warm.base}",
	            strokeWidth: "26px" } },
	        _react2.default.createElement('path', { d: 'm364.78 96.281l-22.906 117.44c5.9091-0.8949 11.966-1.3438 18.125-1.3438 8.3953 0 16.591 0.85947 24.5 2.5l-19.719-118.59zm-87.062 15.031l21.031 117.84c12.096-7.1948 25.552-12.299 39.906-14.875l-60.938-102.97zm173.69 2.4375l-64.125 101.72c14.293 3.3233 27.612 9.2006 39.438 17.125l24.688-118.84zm-249.44 43.031l62.562 102.88c8.6832-11.384 19.356-21.146 31.5-28.812l-94.062-74.062zm323.88 4.5312l-97.5 72.406c11.995 8.3266 22.392 18.802 30.656 30.844l66.844-103.25zm-164.16 64.906c-1.0487-0.0078-2.1059 0.00471-3.1562 0.03125-55.597-0.58048-106.32 50.171-104.66 106-0.4019 47.203 34.268 93.11 80.875 103.19 42.281 10.45 90.54-7.3766 113.78-44.594 24.159-36.188 23.554-87.289-3.4375-121.75-19.366-26.001-50.896-42.633-83.406-42.875zm-213.97 0.3125l96.531 74.094c3.8728-14.16 10.273-27.257 18.688-38.812l-115.22-35.281zm430.38 6.0312l-118.59 32.719c12.939 19.152 20.5 42.241 20.5 67.094 0 66.274-53.726 120-120 120-61.502 0-112.17-46.28-119.16-105.91l-111.56 52.781 123.78-10.469-85.5 90.125 111.62-54.5-47.188 114.94 84.438-91.156-2.5 124.22 45.812-115.5 42.531 116.72 1-124.22 81.844 93.469-43.969-116.22 110.06 57.594-82.969-92.469 123.47 13.938-110.78-56.25 120.16-31.594-123.59-12.469 100.59-72.844zm-334.31 69.812l-121.41 8.7812 118.41 34.719c-0.49736-4.4369-0.78125-8.9303-0.78125-13.5 0-10.355 1.315-20.414 3.7812-30z' })
	      )
	    )
	  );
	};
	
	exports.default = LightIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* import { cssGlobal } from "./cssGlobal"; */
	
	var Html = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1m75acc0'
	})('background:', function (props) {
	  return props.theme.gradient.rightToLeft;
	}, ';position:relative;overflow-x:hidden;text-rendering:optimizeLegibility;font-display:auto;box-sizing:border-box;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:rgba(0,0,0,0);body{color:', function (props) {
	  return props.theme.set.light.p;
	}, ';background-color:', function (props) {
	  return props.theme.set.light.bgText;
	}, ';min-width:300px;margin:0px;}/*::selection{color:', function (props) {
	  return props.theme.colors.pure.white;
	}, ';background-color:', function (props) {
	  return props.theme.colors.warm.base;
	}, ';}*/\na{border:0px;color:', function (props) {
	  return props.theme.colors.warm.base;
	}, ';transition:', function (props) {
	  return props.theme.transitions.main.transition;
	}, ';text-decoration:none;outline:none;&:focus,&:hover{color:', function (props) {
	  return props.theme.colors.warm.base;
	}, ';}text-shadow:', function (props) {
	  return props.theme.set.light.shadow.pop;
	}, ';color:', function (props) {
	  return props.theme.colors.fire.light;
	}, ';}a:not([href]):not([tabindex]){color:inherit;text-decoration:none;&:hover,&:focus{color:inherit;text-decoration:none;}&:focus{outline:0;}}/*\nh1{text-shadow:', function (props) {
	  return props.theme.set.light.shadow.text.small;
	}, ',-1px -1px 0 ', function (props) {
	  return props.theme.colors.warm.base;
	}, ',1px -1px 0 ', function (props) {
	  return props.theme.colors.warm.base;
	}, ',-1px 1px 0 ', function (props) {
	  return props.theme.colors.warm.base;
	}, ',1px 1px 0 ', function (props) {
	  return props.theme.colors.warm.base;
	}, ';}h2{text-shadow:', function (props) {
	  return props.theme.set.light.shadow.text.small;
	}, ',-1px -1px 0 ', function (props) {
	  return props.theme.colors.warm.base;
	}, ',1px -1px 0 ', function (props) {
	  return props.theme.colors.warm.base;
	}, ',-1px 1px 0 ', function (props) {
	  return props.theme.colors.warm.base;
	}, ',1px 1px 0 ', function (props) {
	  return props.theme.colors.warm.base;
	}, ';}*/\nh1{color:', function (props) {
	  return props.theme.set.light.h1;
	}, ';}blockquote{border-left:5px solid ', function (props) {
	  return props.theme.colors.warm.base;
	}, ';padding-left:1rem !important;margin-left:0 !important;margin-right:0 !important;font-style:italic;p{line-height:1.3 !important;}}/*\n.gatsby-resp-image-wrapper{box-shadow:0 10px 30px rgba(0,0,0,0.93);}.gatsby-resp-iframe-wrapper{margin-bottom:2rem;}.gatsby-highlight{margin-bottom:2rem;}*/\n\niframe,.gatsby-resp-iframe-wrapper{scrolling:no;frameborder:0;}[tabindex="-1"]:focus{outline:none !important;}pre{margin-top:0;margin-bottom:1rem;overflow:auto;}figure{margin:0 0 1rem 0;}img{vertical-align:middle;}[role="button"]{cursor:pointer;}a,area,button,[role="button"],input,label,select,summary,textarea{touch-action:manipulation;}button{transition:box-shadow ', function (props) {
	  return props.theme.transitions.main.transition;
	}, ';}caption{padding-top:1.5rem;padding-bottom:1.5rem;color:', function (props) {
	  return props.theme.colors.pure.bright;
	}, ';text-align:center;caption-side:bottom;}label{display:inline-block;margin-bottom:0.5rem;}button:-moz-focus-inner{border:0;}button:focus{outline:0px dotted;outline:0px auto -webkit-focus-ring-color;}input,button,select,textarea{line-height:inherit;outline:none;}input[type="date"],input[type="time"],input[type="datetime-local"],input[type="month"]{-webkit-appearance:listbox;}p{position:relative;z-index:1;top:0px;}fieldset{min-width:0;padding:0;margin:0;border:0;}legend{display:block;width:100%;padding:0;margin-bottom:0.5rem;line-height:inherit;}input[type="search"]{-webkit-appearance:none;}output{display:inline-block;}[hidden]{display:none !important;}.headroom-wrapper{position:fixed;width:100%;z-index:2000;align:center;font-size:1rem;.headroom--pinned{}}.headroom{display:flex;justify-content:space-between;flex-direction:row;width:100%;/*\n  border-bottom:2px solid transparent;*/\n  padding:1rem 1.5rem;svg{height:2.5rem;g{}}}.headroom--unfixed{position:relative;transform:translateY(0);transition:', function (props) {
	  return props.theme.transitions.headroom.transition;
	}, ';}.headroom--scrolled{transition:', function (props) {
	  return props.theme.transitions.headroom.transition;
	}, ';}.headroom--unpinned{position:absolute;transform:translateY(-100%);transition:', function (props) {
	  return props.theme.transitions.headroom.transition;
	}, ';}.headroom--pinned{position:fixed;transform:translateY(0);transition:', function (props) {
	  return props.theme.transitions.headroom.transition;
	}, ';box-shadow:', function (props) {
	  return props.theme.set.light.shadow.topNav;
	}, ';headroom-wrapper{}/*\nnav{a{border-bottom:2px solid ', function (props) {
	  return props.theme.set.light.highlight;
	}, ';color:', function (props) {
	  return props.theme.colors.cool.ink;
	}, ';&:hover{border-color:', function (props) {
	  return props.theme.colors.cool.ink;
	}, ';border-bottom:2px solid ', function (props) {
	  return props.theme.set.light.highlight;
	}, ';svg{g{fill:', function (props) {
	  return props.theme.colors.warm.base;
	}, ';}}}&:focus{color:', function (props) {
	  return props.theme.colors.cool.lead;
	}, ';}}}*/\n\n  padding-top:0.75rem;padding-bottom:0.75rem;svg{height:2.5rem;g{fill:', function (props) {
	  return props.theme.colors.fire.light;
	}, ';}}span{color:', function (props) {
	  return props.theme.colors.cool.ink;
	}, ';}'); /* eslint no-unused-expressions: 0 */
	
	var Body = function Body(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      Html,
	      null,
	      children
	    )
	  );
	};
	exports.default = Body;
	
	
	Body.propTypes = {
	  children: _propTypes2.default.array
	};
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CssGlobal = undefined;
	
	var _emotion = __webpack_require__(24);
	
	var _theme = __webpack_require__(14);
	
	var CssGlobal = exports.CssGlobal = '\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\nhtml {\n  text-rendering: optimizeLegibility;\n  font-display: auto;\n\n  body { \n    min-width: 300px;\n  }\n\n  /* safari overflow */\n  html, body {\n    position: relative;\n    overflow-x: hidden;\n    margin: 0;\n\n  }\n\n}\n  ::selection {\n    color: white;\n    background-color: ' + _theme.theme.colors.warm.base + ';\n  }\n/*\nhtml {\n  text-rendering: optimizeLegibility;\n  font-display: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  @media (max-width: ' + _theme.theme.breakpoints.m + '),\n    (max-device-width: ' + _theme.theme.breakpoints.m + ') {\n    font-size: 16px !important h1 {\n      font-size: 2.074rem;\n    }\n    h2 {\n      font-size: 1.728rem;\n    }\n    h3 {\n      font-size: 1.44rem;\n    }\n    h4 {\n      font-size: 1.2rem;\n    }\n  }\n  @media (max-width: ' + _theme.theme.breakpoints.s + '),\n    (max-device-width: ' + _theme.theme.breakpoints.s + ') {\n    font-size: 14px !important;\n    h1 {\n      font-size: 2.65rem;\n    }\n    h2 {\n      font-size: 1.424rem;\n    }\n    h3 {\n      font-size: 1.266rem;\n    }\n    h4 {\n      font-size: 1.125rem;\n    }\n  }\n  @media (max-width: ' + _theme.theme.breakpoints.xs + '),\n    (device-width: ' + _theme.theme.breakpoints.xs + ') {\n    font-size: 10.5px !important;\n    h1 {\n      font-size: 2.5rem;\n    }\n    h2 {\n      font-size: 1.125rem;\n    }\n    h3 {\n      font-size: 1rem;\n    }\n    h4 {\n      font-size: 0.8125rem;\n    }\n  }\n}\n\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n  &:hover,\n  &:focus {\n    color: inherit;\n    text-decoration: none;\n  }\n  &:focus {\n    outline: 0;\n  }\n}\nh1 {\n  text-shadow: ' + _theme.theme.set.light.shadow.text.small + ',-1px -1px 0 ' + _theme.theme.colors.warm.base + ',\n        1px -1px 0 ' + _theme.theme.colors.warm.base + ',\n        -1px 1px 0 ' + _theme.theme.colors.warm.base + ',\n        1px 1px 0 ' + _theme.theme.colors.warm.base + ';\n}\nh2 {\n  text-shadow: ' + _theme.theme.set.light.shadow.text.small + ',-1px -1px 0 ' + _theme.theme.colors.warm.base + ',\n        1px -1px 0 ' + _theme.theme.colors.warm.base + ',\n        -1px 1px 0 ' + _theme.theme.colors.warm.base + ',\n        1px 1px 0 ' + _theme.theme.colors.warm.base + ';\n}\n\nblockquote {\n  border-left: 5px solid ' + _theme.theme.colors.warm.base + ';\n  padding-left: 1rem !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  font-style: italic;\n  p {\n    line-height: 1.3 !important;\n  }\n}\n\niframe, .gatsby-resp-iframe-wrapper {\n  scrolling: no;\n  frameborder: 0;\n}\n[tabindex="-1"]:focus {\n  outline: none !important;\n}\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n}\nfigure {\n  margin: 0 0 1rem 0;\n}\nimg {\n  vertical-align: middle;\n}\n[role="button"] {\n  cursor: pointer;\n}\na,\narea,\nbutton,\n[role="button"],\ninput,\nlabel,\nselect,\nsummary,\ntextarea {\n  touch-action: manipulation;\n}\nbutton {\n  transition: box-shadow ' + _theme.theme.transitions.main.transition + ';\n}\ntable {\n  border-collapse: collapse;\n  background-color: ' + _theme.theme.colors.pure.white + ';\n}\ncaption {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n  color: ' + _theme.theme.colors.pure.bright + ';\n  text-align: center;\n  caption-side: bottom;\n}\nth {\n  text-align: left;\n}\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\nbutton:-moz-focus-inner {\n  border: 0;\n}\n\nbutton:focus {\n  outline: 0px dotted;\n  outline: 0px auto -webkit-focus-ring-color;\n}\ninput,\nbutton,\nselect,\ntextarea {\n  line-height: inherit;\n  outline: none;\n}\ninput[type="date"],\ninput[type="time"],\ninput[type="datetime-local"],\ninput[type="month"] {\n  -webkit-appearance: listbox;\n}\ntextarea {\n  resize: vertical;\n}\n\np {\n  position: relative;\n  z-index: 1;\n  top: 0px;\n}\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n}\ninput[type="search"] {\n  -webkit-appearance: none;\n}\noutput {\n  display: inline-block;\n}\n[hidden] {\n  display: none !important;\n}\n.headroom-wrapper {\n  position: fixed;\n  width: 100%;\n  z-index: 2000;\n  align: center;\n  .headroom--pinned {\n\n  }\n\n}\n.headroom {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  width: 100%;\n  border-bottom: 2px solid transparent;\n  padding: 1rem 1.5rem;\n  svg {\n    height: 2.5rem;\n    g {\n    }\n  }\n}\n.headroom--unfixed {\n  position: relative;\n  transform: translateY(0);\n  transition: ' + _theme.theme.transitions.headroom.transition + ';\n}\n.headroom--scrolled {\n  transition: ' + _theme.theme.transitions.headroom.transition + ';\n}\n.headroom--unpinned {\n  position: absolute;\n  transform: translateY(-100%);\n  transition: ' + _theme.theme.transitions.headroom.transition + ';\n}\n.headroom--pinned {\n  position: fixed;\n  transform: translateY(0);\n  transition: ' + _theme.theme.transitions.headroom.transition + ';\n  box-shadow: ' + _theme.theme.set.light.shadow.topNav + ';\n\n  headroom-wrapper{\n  }\n\n  nav {\n    a {\n      color: ' + _theme.theme.colors.cool.ink + ';\n      &:hover {\n        border-color: ' + _theme.theme.colors.cool.ink + ';\n        border-bottom: 2px solid ' + _theme.theme.set.light.highlight + ';\n        svg {\n          g {\n              fill: ' + _theme.theme.colors.warm.base + ';\n            }\n        }\n      }\n      &:focus {\n        color: ' + _theme.theme.colors.cool.lead + ';\n      }\n    }\n  }\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  svg {\n    height: 2.5rem;\n    g {\n      fill: ' + _theme.theme.colors.fire.light + ';\n    }\n  }\n  span {\n    color: ' + _theme.theme.colors.cool.ink + ';\n  }\n  nav {\n  }\n}\n*/\n';

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotionTheming = __webpack_require__(415);
	
	var _theme = __webpack_require__(14);
	
	var _SEO = __webpack_require__(41);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Navigation = __webpack_require__(280);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Body = __webpack_require__(287);
	
	var _Body2 = _interopRequireDefault(_Body);
	
	var _OrbContainer = __webpack_require__(192);
	
	var _emotion = __webpack_require__(24);
	
	var _CssGlobal = __webpack_require__(288);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint no-unused-expressions: 0 */
	
	(0, _emotion.injectGlobal)(_theme.theme.cssGlobal);
	
	var MainLayout = function MainLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _emotionTheming.ThemeProvider,
	    { theme: _theme.theme },
	    _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_SEO2.default, null),
	      _react2.default.createElement(
	        _Body2.default,
	        { onLoad: (0, _OrbContainer.setTheme)() },
	        _react2.default.createElement(_Navigation2.default, null),
	        children()
	      )
	    )
	  );
	};
	
	exports.default = MainLayout;
	
	
	MainLayout.propTypes = {
	  children: _propTypes2.default.func.isRequired
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-29e088a355fe3c6b2d98.js